import React from 'react';
import {entity as widgetSnippets} from '../../ducks/widgetSnippets';
import SnippetList from './SnippetList';
import SnippetEditor from './SnippetEditor';
import duckify from "../../utils/duckify";
import {withSnippetFunctions} from "./snippetUtils";
import {compose} from "redux";

const WidgetSnippetList = (props) => (
  <SnippetList
    collectionButtons={[]}
    displayName="Widget"
    editModal={SnippetEditor}
    editModalProps={{htmlAllowDangerousTags: true}}
    type="widget"
    {...props}
  />
);

const mapDucksToProps = () => ({
  items: widgetSnippets
});

export default compose(
  withSnippetFunctions(widgetSnippets),
  duckify(mapDucksToProps)
)(WidgetSnippetList);
